import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticles = articles.slice(0, 3);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-8">
        <div className="flex items-end justify-between mb-12">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              体育资讯
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新体育动态与专业解读
            </h2>
          </div>
          <Link
            to="/articles"
            className="hidden md:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500/90 backdrop-blur-sm text-background-50 text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <Link
            to="/articles"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}